import React, { useEffect, useState } from "react";
import {
  BrowserRouter as Router,
  Route,
  Switch,
  useLocation,
} from "react-router-dom";
import MyProfile from "routes/MyProfile";
import New from "routes/New";
import PageNotFound from "routes/PageNotFound";
import Profile from "routes/Profile";
import RedirectToHome from "routes/RedirectToHome";
import Settings from "routes/Settings";
import SuggestFeature from "routes/SuggestFeature";
import Auth from "../routes/Auth";
import Home from "../routes/Home";
import Footer from "./Footer";
import Header from "./Header";

const AppRouter = ({ isLoggedIn }) => {

  return (
    <Router>
      <Header />
      {isLoggedIn ? (
        <Switch>
          <Route exact path="/">
            <Home isLoggedIn={isLoggedIn} />
          </Route>
          <Route exact path="/new">
            <New />
          </Route>
          <Route exact path="/settings">
            <Settings />
          </Route>
          <Route exact path="/feedback">
            <SuggestFeature />
          </Route>
          <Route exact path="/u">
            <MyProfile />
          </Route>
          <Route exact path="/u/:uid">
            <Profile/>
          </Route>
          {/* other pages like my profile, new post(or project), ... */}
          {/* after adding a page, edit the title of header */}
          <Route exact path="/auth">
            <RedirectToHome />
          </Route>
          <Route component={PageNotFound} />
        </Switch>
      ) : (
        <Switch>
          {/* The page that will allow not-signed in user to view */}
          <Route exact path="/">
            <Home isLoggedIn={isLoggedIn} />
          </Route>
          <Route exact path="/feedback">
            <SuggestFeature />
          </Route>
          <Route exact path="/u/:uid">
            <Profile/>
          </Route>
          {/* <Route exact path="/post">
              <Post />
            </Route> */}
          {/* The page that will NOT allow not-signed in user to view */}
          {/* like my profile, except for the post page... */}
          {/* -->  로그인 안 한 유저가 접근하려고 하면 로그인하라고 할 것임.*/}

          <Route>
            <Auth />
          </Route>
        </Switch>
      )}
      <Footer />
    </Router>
  );
};

export default AppRouter;
